import { render, staticRenderFns } from "./errorText.vue?vue&type=template&id=0d388ef6&scoped=true&"
import script from "./errorText.vue?vue&type=script&lang=js&"
export * from "./errorText.vue?vue&type=script&lang=js&"
import style0 from "./errorText.vue?vue&type=style&index=0&id=0d388ef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d388ef6",
  null
  
)

export default component.exports